export default function formatDateTime(
  date: Date
): { date: string; time: string } {
  const formatList = Intl.DateTimeFormat("fi-FI", {
    dateStyle: "short",
    timeStyle: "short",
  }).formatToParts(date);
  formatList[7].value = ":";
  const dateAndtime = formatList
    .map(({ value }) => {
      return value;
    })
    .join("")
    .split(" ");

  return { date: dateAndtime[0], time: dateAndtime[1] };
}
